import { m, LazyMotion, domAnimation } from "framer-motion";
import AnimatedLetter from "./AnimatedLetter";


const AnimatedText = ({ text }) => { // TODO: the name is misleading ... this is a section
    return (
        <LazyMotion features={domAnimation} strict>
            <m.div
                initial={{ x: -300 }}
                whileInView={{ x: 0 }}
                transition={{ duration: 0.7, type: "spring" }}
                className="text-primary-400 p-6 select-none"

            >

                <m.h2
                    className="tracking-wider text-7xl sm:text-8xl md:text-9xl"
                >
                    {text.split("").map((char, index) => AnimatedLetter({ char, index }))}

                </m.h2>



            </m.div>
        </LazyMotion>
    );
}

export default AnimatedText;
